import React from 'react'

export default function Loding() {
  return (
    <div className="loding-cont center">
        <span class="loader"></span>
    </div>
  )
}
